import { useTranslation } from '@crehana/i18n';
import { createImgixPlaceholder, CustomNextImage } from '@crehana/next';

import { StyledCard } from './Leaders.styles';

import { LeaderCardProps } from './types';

const LeaderCard: React.FC<LeaderCardProps> = ({
  avatar,
  description,
  companyLogo,
  name,
  role,
}) => {
  const { t } = useTranslation();
  return (
    <StyledCard
      className="bg-white shadow-dropdown px-40 pt-40 pb-32 m-auto flex flex-col items-end"
      style={{ borderRadius: 20 }}
    >
      <div className="flex flex-row items-center self-start">
        <div className="relative rounded-full h-56 w-56 mr-20 overflow-hidden">
          <CustomNextImage
            src={avatar}
            blurDataURL={createImgixPlaceholder(avatar)}
            layout="fill"
            alt="Hero background"
            objectFit="contain"
            objectPosition="bottom center"
            placeholder="blur"
          />
        </div>
        <div className="flex flex-col text-left">
          <p className="text-14 font-nun leading-14 uppercase font-bold">
            {name}
          </p>
          <p className="text-12 leading-18 font-nun mt-4">{t(role)}</p>
        </div>
      </div>

      <div className="mt-24">
        <p className="font-body2 text-left">{t(description)}</p>
      </div>

      <div className="relative w-80 h-32 mt-auto">
        <CustomNextImage
          src={companyLogo}
          blurDataURL={createImgixPlaceholder(companyLogo)}
          layout="fill"
          alt="Hero background"
          objectFit="contain"
          objectPosition="bottom center"
          placeholder="blur"
        />
      </div>
    </StyledCard>
  );
};

export default LeaderCard;
